jQuery(function($){

  $(document).on('click', '.calendar-button', function(e){
    e.preventDefault();
    $('.calendar-modal').show();
  });

  $(document).on('click', function(e){
    var $target = $(e.target);
    if (
      $target.is('.close-calendar') ||
      ($target.closest('.calendar-wrapper').length === 0 && $target.closest('.calendar-modal').length)
    ) {
      $('.calendar-modal').hide();
    }
  });

});


jQuery(function ($) {
  var $wrap = $('.calendar-wrapper');
  var $months = $wrap.find('.calendar-month');
  if (!$months.length) return;

  var $left = $wrap.find('#cal-arrow-left');
  var $right = $wrap.find('#cal-arrow-right');
  var i = 0;

  function showMonth() {
    $months.hide().eq(i).show();
    if (i === 0) $left.addClass('inactive'); else $left.removeClass('inactive');
    if (i === $months.length - 1) $right.addClass('inactive'); else $right.removeClass('inactive');
  }

  showMonth();

  $left.on('click', function () {
    if ($(this).hasClass('inactive')) return;
    i = Math.max(0, i - 1);
    showMonth();
  });

  $right.on('click', function () {
    if ($(this).hasClass('inactive')) return;
    i = Math.min($months.length - 1, i + 1);
    showMonth();
  });
});
